import { agentApiPath, partnerServicePath, servicePath } from "constants/defaultValues";
import { put, takeEvery } from "redux-saga/effects";
import { bearerReq, bearerRequest, request } from "services/requests.services";
import { ADD_USER_FOLLOW_UP_FAILED, ADD_USER_FOLLOW_UP_SUCCESS, CHANGE_PARTNER_USER_FAILED, CHANGE_PARTNER_USER_SUCCESS, GET_PARTNER_USERS, GET_PARTNER_USERS_SUCCESS, GET_PARTNER_USERS_REPORT_SUCCESS, GET_SINGLE_PARTNER_USER, GET_SINGLE_PARTNER_USER_FAILED, GET_SINGLE_PARTNER_USER_SUCCESS, GET_DAILY_TASK_LIST_SUCCESS, GET_DAILY_TASK_LIST_FAILED, UPLOAD_RECORDING_SUCCESS, GET_DAILY_TASK_LIST, UPLOAD_RECORDING_FAILED, GET_PARTNER_CASES_SUCCESS, GET_PARTNER_CASES_FAILED, DOWNLOAD_DAILY_TASK_SUCCESS, DOWNLOAD_DAILY_TASK_FAILED } from "./Action";
import { NotificationManager } from "components/common/react-notifications";
import { toast } from "helpers/Utils";

function* getUserData(action) {
  try {
    const { searchKeyword } = action.state;
    const data = yield bearerRequest("GET", `${agentApiPath}/users?page=${action.state.page}&searchKeyword=${searchKeyword}`);
    yield put({ type: "USERS_GET_LIST_SUCCESS", data: data });
  } catch (error) {
    yield put({
      type: "USERS_GET_LIST_FAILED",
      message: "Failed to get data !"
    });
  }
}

function* getStatusBucket() {
  try {
    const data = yield request("GET", `${servicePath}/insurance/getStatusBuckets`);
    yield put({ type: "USER_GET_STATUS_BUCKET_SUCCESS", data: data.data });
  } catch (error) {
    yield put({
      type: "USER_GET_STATUS_BUCKET_FAILED",
      message: "Failed to get data !"
    });
  }
}

function* getAssignUser() {
  try {
    const data = yield bearerRequest("GET", `${agentApiPath}/assignUser`);
    yield put({ type: "USER_GET_ASSIGN_USER_SUCCESS", data: data.data });
  } catch (error) {
    yield put({
      type: "USER_GET_ASSIGN_USER_FAILED",
      message: "Failed to get data !"
    });
  }
}

function* getAssignExecutive() {
  try {
    const data = yield bearerRequest("GET", `${agentApiPath}/assignLegalExecutive`);
    yield put({ type: "GET_ASSIGN_LEGAL_EXECUTIVE_SUCCESS", data: data.data });
  } catch (error) {
    yield put({
      type: "GET_ASSIGN_LEGAL_EXECUTIVE_FAILED",
      message: "Failed to get data !"
    });
  }
}

function* getInternalLegalExecutive() {
  try {
    const data = yield bearerRequest("GET", `${agentApiPath}/internalLegalExecutive`);
    yield put({ type: "GET_INTERNAL_LEGAL_EXPERT_SUCCESS", data: data.data });
  } catch (error) {
    yield put({
      type: "GET_INTERNAL_LEGAL_EXPERT_FAILED",
      message: "Failed to get data !"
    });
  }
}

function* getAssignSubExecutive() {
  try {
    const data = yield bearerRequest("GET", `${agentApiPath}/getLegalSubExecutive`);
    yield put({ type: "USER_GET_LEGAL_SUBEXECUTIVE_SUCCESS", data: data.data });
  } catch (error) {
    yield put({
      type: "USER_GET_LEGAL_SUBEXECUTIVE_FAILED",
      message: "Failed to get data !"
    });
  }
}

function* updateUser(action) {
  try {
    const data = yield bearerRequest("POST", `${agentApiPath}/updatedStatus`, { ...action.state });

    yield put({ type: "USERS_GET_LIST", state: { page: action?.currentPage, searchKeyword: action.state?.searchKeyword ? action.state?.searchKeyword.trim() : "" } });
    yield put({ type: "USER_UPDATE_USER_SUCCESS", data: data.message });
  } catch (error) {
    yield put({
      type: "USER_UPDATE_USER_FAILED",
      message: "Failed to get data !"
    });
  }
}

function* addUser(action) {
  try {
    const data = yield bearerRequest("POST", `${agentApiPath}/addUser`, { ...action.state });
    yield put({ type: "USERS_GET_LIST", state: { page: action?.currentPage } });
    yield put({ type: "USER_ADD_USER_SUCCESS", data: data });
  } catch (error) {
    yield put({
      type: "USER_ADD_USER_FAILED",
      message: "Failed to get data !"
    });
  }
}

function* updatePassword(action) {
  try {
    const data = yield bearerRequest("POST", `${agentApiPath}/updatedPassword`, { ...action.state });
    yield put({ type: "USER_UPDATE_PASSWORD_SUCCESS", data: data.message });
  } catch (error) {
    yield put({
      type: "USER_UPDATE_PASSWORD_FAILED",
      message: "Failed to Update !"
    });
  }
}

function* getPartnerUsers(action) {
  try {
    const { searchKeyword, todayFollowUp, enableCCE, isFEM, followUpStatus, isPolifyx } = action.state;
    const url = `${partnerServicePath}/user/partnerUserList?page=${action.state.page}` + `&search=${searchKeyword}` + `&todayFollowUp=${todayFollowUp}` + `&enableCCE=${enableCCE}` + (isFEM ? `&isFEM=${isFEM}` : "") + (followUpStatus ? `&followUpStatus=${followUpStatus}` : "") + (isPolifyx ? `&isPolifyx=true` : "");

    const data = yield request("GET", url, { ...action.state });
    yield put({ type: GET_PARTNER_USERS_SUCCESS, data: data.data.users, count: data.data.count });
  } catch (error) {
    yield put({
      type: "GET_PARTNER_USERS_FAILED",
      message: "Failed to get data !"
    });
  }
}

function* getPartnerUsersReport(action) {
  try {
    const isFEM = action?.state?.isFEM || false;
    const isPolifyx = action?.state?.isPolifyx || false;
    const queryString = isFEM ? `?isFEM=${isFEM}` : `?isPolifyx=${isPolifyx}`;
    const data = yield request("GET", `${partnerServicePath}/user/partnerUsersReport/download${queryString}`);

    yield put({ type: GET_PARTNER_USERS_REPORT_SUCCESS, data });
  } catch (error) {
    yield put({
      type: "GET_PARTNER_USERS_REPORT_FAILED",
      message: "Failed to get report !"
    });
  }
}

function* getSinglePartnerUser(action) {
  try {
    const data = yield request("GET", `${partnerServicePath}/user/partnerUserList?userId=${action.state.id}`);
    yield put({ type: GET_SINGLE_PARTNER_USER_SUCCESS, data: data.data });
  } catch (error) {
    yield put({
      type: GET_SINGLE_PARTNER_USER_FAILED,
      message: "Failed to fetch !"
    });
  }
}

function* addUserFollowUp(action) {
  const payload = action.state;
  try {
    yield request("POST", `${partnerServicePath}/user/addFollowUp`, payload);
    yield put({
      type: ADD_USER_FOLLOW_UP_SUCCESS,
      message: "Follow Up Added Successfully"
    });
    if (!payload.isTaskSection) {
      yield put({
        type: GET_SINGLE_PARTNER_USER,
        state: { id: payload.userId }
      });
    }
  } catch (error) {
    yield put({
      type: ADD_USER_FOLLOW_UP_FAILED,
      message: "Failed to fetch !"
    });
  }
}

function* changePartnerUser(action) {
  const payload = action.state;
  try {
    const res = yield request("POST", `${partnerServicePath}/user/updateAgent`, payload);

    if (!res || res.status !== 200) {
      throw new Error("Unauthorized or Bad Request");
    }

    yield put({
      type: CHANGE_PARTNER_USER_SUCCESS,
      message: "Partner Executive Changed Successfully"
    });
    yield put({
      type: GET_PARTNER_USERS,
      state: {
        page: payload.page,
        searchKeyword: payload.searchKeyword,
        enableCCE: payload.enableCCE,
        isFEM: payload.isFEM,
        isPolifyx: payload.isPolifyx,
        followUpStatus: payload.followUpStatus
      }
    });
  } catch (error) {
    yield put({
      type: CHANGE_PARTNER_USER_FAILED,
      message: "Failed to change !"
    });
  }
}
function* getExcutiverNamesList() {
  try {
    const data = yield bearerRequest("GET", `${partnerServicePath}/user/executiveList`);
    yield put({ type: "GET_EXECUTIVE_NAME_SUCCESS", data: data.data });
  } catch (error) {
    yield put({
      type: "GET_EXECUTIVE_NAME_FAILED",
      message: "Failed to get data !"
    });
  }
}
function* getDailyTaskSaga(action) {
  try {
    const response = yield bearerReq("POST", `${partnerServicePath}/user/dailyPemTaskList`, action.state);
    if (response.success) {
      yield put({
        type: GET_DAILY_TASK_LIST_SUCCESS,
        payload: response.data
      });
    } else {
      yield put({
        type: GET_DAILY_TASK_LIST_FAILED
      });

      NotificationManager.error(response.message || "Unable to fetch Daily Task List.");
    }
  } catch (error) {
    yield put({
      type: GET_DAILY_TASK_LIST_FAILED
    });

    NotificationManager.error("Something went wrong.");
  }
}
function* uploadRecordingSaga(action) {
  try {
    const response = yield bearerReq("POST", `${partnerServicePath}/user/uploadRecording/${action.payload.id}`, action.payload.data);
    if (response.success) {
      yield put({
        type: UPLOAD_RECORDING_SUCCESS
      });

      toast("Recording uploaded successfully.", "Success", "success");

      // Refresh list
      yield put({
        type: GET_DAILY_TASK_LIST,
        state: action.payload.refreshPayload
      });
    } else {
      yield put({
        type: UPLOAD_RECORDING_FAILED
      });

      toast(response.message || "Upload failed.", "Failed", "error");
    }
  } catch (error) {
    yield put({
      type: UPLOAD_RECORDING_FAILED
    });

    toast(error.response?.data?.message || error.message || "Unable to upload recording.", "Failed", "error");
  }
}
function* getPartnerCasesSaga(action) {
  try {
    const response = yield bearerReq("GET", `${partnerServicePath}/user/getComplaints/${action.state.partnerId}/?page=${action.state.page}&size=${action.state.size}`);

    if (response.success) {
      yield put({
        type: GET_PARTNER_CASES_SUCCESS,
        payload: response.data
      });
    } else {
      yield put({
        type: GET_PARTNER_CASES_FAILED
      });
    }
  } catch (error) {
    yield put({
      type: GET_PARTNER_CASES_FAILED
    });
  }
}
function* downloadDailyTaskReportSaga(action) {
  try {
    const response = yield bearerReq("POST", `${partnerServicePath}/user/dailyPemTaskList/download`, action.state);

    if (response) {
      const blob = new Blob([response], {
        type: "text/csv;charset=utf-8;"
      });

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Daily_Task_List.csv");

      document.body.appendChild(link);
      link.click();
      link.remove();

      yield put({
        type: DOWNLOAD_DAILY_TASK_SUCCESS
      });
    }
  } catch (err) {
    yield put({
      type: DOWNLOAD_DAILY_TASK_FAILED
    });
  }
}
export default function* userSaga() {
  yield takeEvery("USERS_GET_LIST", getUserData);
  yield takeEvery("USER_GET_STATUS_BUCKET", getStatusBucket);
  yield takeEvery("USER_GET_ASSIGN_USER", getAssignUser);
  yield takeEvery("GET_ASSIGN_LEGAL_EXECUTIVE", getAssignExecutive);
  yield takeEvery("USER_GET_LEGAL_SUBEXECUTIVE", getAssignSubExecutive);
  yield takeEvery("USER_UPDATE_USER", updateUser);
  yield takeEvery("USER_ADD_USER", addUser);
  yield takeEvery("USER_UPDATE_PASSWORD", updatePassword);
  yield takeEvery("GET_INTERNAL_LEGAL_EXPERT", getInternalLegalExecutive);
  yield takeEvery("GET_PARTNER_USERS", getPartnerUsers);
  yield takeEvery("GET_PARTNER_USERS_REPORT", getPartnerUsersReport);
  yield takeEvery("GET_SINGLE_PARTNER_USER", getSinglePartnerUser);
  yield takeEvery("ADD_USER_FOLLOW_UP", addUserFollowUp);
  yield takeEvery("CHANGE_PARTNER_USER", changePartnerUser);
  yield takeEvery("GET_EXECUTIVE_NAME", getExcutiverNamesList);
  yield takeEvery("GET_DAILY_TASK_LIST", getDailyTaskSaga);
  yield takeEvery("UPLOAD_RECORDING", uploadRecordingSaga);
  yield takeEvery("GET_PARTNER_CASES", getPartnerCasesSaga);
  yield takeEvery("DOWNLOAD_DAILY_TASK", downloadDailyTaskReportSaga);
}
